import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {currentMedia} from '../../../../styledComponents/ResponsiveConvenience'
import {
  DefaultStyledButton,
  PlainStyledButton,
  PrimaryStyledButton,
  UnstyledLinkStyledButton
} from '../../../../styledComponents/Button'
import {StyledPageTitle} from '../../../../components/reservations/components/CommonStyle'
import {StyledDiv} from '../../../../styledComponents/StyledTypeDefinitions'
import {GuestBackArrow} from '../../../../styledComponents/Links'

export const ApplyButton = styled(PrimaryStyledButton)`
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 15px;
`
export const SecondaryButton = styled(PlainStyledButton)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 50px;
  width: 100%;
  max-width: 384px;

  border: 1px solid rgba(0, 112, 176, 0.5);
  border-radius: 8px;

  color: ${Colors.Primary};
  background-color: ${Colors.Surface};


  :active {
    background-color: ${Colors.SecondaryActive};
    box-shadow: none;
  }

  :disabled  {
    color: ${Colors.AccentLight};
    pointer-events: none;
    border: 1px solid ${Colors.AccentLight};
    background-color: ${Colors.Surface};
    box-shadow: none;
  }
`

export const ItemHeading = styled.div`
  background-color: ${Colors.AccentLight};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 5px 15px;
  box-sizing: border-box;
  overflow: hidden;
`

export const WideWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 15px;
  box-sizing: border-box;
  overflow: hidden;
`

export const PageTitle = styled(StyledPageTitle)`
  line-height: 1;
`

export const BoldText = styled.span<{ fontColor?: string }>`
  font-weight: ${FontWeights.Bold};
  ${props => props.fontColor ? `
    color:${props.fontColor};
  ` : ''}
`

export const ListGridContainer = styled.div<{ fontSize?: string }>`
  display: grid;
  grid-template-columns: min-content auto;
  ${props => props.fontSize ? `
    font-size:${props.fontSize};
  ` : ''}
`

export const NumberListContainer: StyledDiv = styled.div`
  counter-reset: number 0;
  margin-left: 10px;
`

export const NumberListItem: StyledDiv = styled.div`
   display: flex;
   align-items: baseline;
   margin: 0 0 5px;

   &::before {
    counter-increment: number;
    content: counter(number)".";
    margin: 0 5px 0 0;
    flex-shrink: 0;
  }
`

export const PledgeArea = styled.div<{ fontSize?: string }>`
  background-color: ${Colors.Surface};
  margin: 0 15px;
  ${currentMedia.lessThan('sp')`
    margin: 0;
  `};
  box-sizing: border-box;
  overflow: hidden;
  ${props => props.fontSize ? `
    font-size:${props.fontSize};
  ` : ''}
`

export const PolicyCheckBoxStyled = styled.label`
  font-size: ${FontSize.Body};
`
export const GuestApplyButton = styled(PrimaryStyledButton)`
  background: ${Colors.GuestPrimary};
  border: 1px solid ${Colors.GuestPrimary};
  box-shadow: 0 2px 0 0 ${Colors.GuestPrimaryVariant};
  :active {
    background-color: ${Colors.GuestPrimary};
    box-shadow: none;
  }
`

export const GuestBackButton = styled(DefaultStyledButton)`
  color: ${Colors.GuestPrimary};
  background: ${Colors.Background};
  border: 1px solid ${Colors.GuestPrimary};
  box-shadow: none;
  font-size: ${FontSize.Body};
`
export const GuestPlainLinkStyledButton = styled(UnstyledLinkStyledButton)`
  color: ${Colors.GuestPrimary};
`

export const GuestPlainLinkStyledBackButton = styled(GuestPlainLinkStyledButton)`
  position: relative;
  padding-left: 15px;
  text-align: left;
  margin: 0;

  :before {
    ${GuestBackArrow};
  }
`
